// @flow
import environment from '../../../environment/index';
import { getCreator, putCreator } from '../../../http';

export const endpoints = Object.freeze({
  GET_NOTIFICATIONS: `${environment.apiUrl}/preferences/notifications`,
  PUT_NOTIFICATIONS: `${environment.apiUrl}/preferences/notifications`,
});

export const getNotificationsApi = getCreator(fetch, endpoints.GET_NOTIFICATIONS);
export const putNotificationsApi = putCreator(fetch, endpoints.PUT_NOTIFICATIONS);



// WEBPACK FOOTER //
// ./src/modules/preferences/notifications/api.js